import useFeatureFlags, { FEATURE_FLAGS } from "./use-feature-flags";

interface UseAssessmentReportEnabledReturn {
  enabled: boolean;
  /**
   * Whether the answer is known yet. Callers branch on this rather than on a
   * request being in flight — see `resolved` on useFeatureFlags for why the
   * difference matters.
   */
  resolved: boolean;
}

// Gates the post-assessment report.
export default function useAssessmentReportEnabled(): UseAssessmentReportEnabledReturn {
  const { isEnabled, resolved } = useFeatureFlags();

  return {
    enabled: isEnabled(FEATURE_FLAGS.ASSESSMENT_REPORT),
    resolved,
  };
}
